module.exports = __webpack_public_path__ + "static/img/welcome.b4e6d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome.png
// module id = LBz+
// module chunks = 1